module.exports = __webpack_public_path__ + "static/media/tasks.1bdb2252.svg";